export { default, getStaticProps } from './not-found'
